import Toggle from '@betterfunnel/ui-core/Toggle';
import { useEffect, useState } from 'react';
import SettingsHelpTooltip from './SettingsHelpTooltip';

interface Props {
  title?: string;
  editable?: boolean;
  value?: boolean;
  setValue?: any;
  update?: any;
  helpText?: string;
}

export default function SettingSectionToggle({
  title,
  editable,
  value,
  setValue,
  update,
  helpText,
}: Props) {
  const [editing, setEditing] = useState(false);
  const [initialValue, setInitialValue] = useState<boolean>();

  useEffect(() => {
    if (editing) {
      setInitialValue(value as boolean);
    }
  }, [editing]);

  return (
    <div className="pt-6 sm:flex">
      <dt className="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">
        <div className="flex items-center gap-2">
          {title}
          {helpText && <SettingsHelpTooltip text={helpText} iconSize="sm" />}
        </div>
      </dt>
      <dd className="mt-1 flex justify-between gap-x-6 sm:mt-0 sm:flex-auto">
        {!editing ? (
          <div className="text-gray-900">{value ? 'Enabled' : 'Disabled'}</div>
        ) : (
          <Toggle
            key={'edit-name'}
            checked={value}
            onChange={(v) => setValue(v)}
          />
        )}
        <div className="flex gap-4">
          {editing ? (
            <button
              type="button"
              className="font-semibold text-gray-600 hover:text-gray-500"
              onClick={() => {
                {
                  setValue(initialValue);
                  setEditing((a) => !a);
                }
              }}
            >
              Cancel
            </button>
          ) : (
            <></>
          )}
          {editable ? (
            <button
              type="button"
              className="font-semibold text-indigo-600 hover:text-indigo-500"
              onClick={() => {
                setEditing((a) => !a);
                if (editing) {
                  update();
                }
              }}
            >
              {editing ? 'Save' : 'Edit'}
            </button>
          ) : (
            <></>
          )}
        </div>
      </dd>
    </div>
  );
}
